<mat-checkbox
  (change)="change.emit($event)"
  [checked]="!!data.value"
  [formControl]="control"
  [name]="data.name"
  [ngClass]="{'text-error': control.errors}"
  [required]="data.attributes?.required ?? false"
  [value]="data.returnValue ?? 'true'"
  color="primary"
>
  {{ data.label }}
</mat-checkbox>

@if (control.errors) {
  <mat-error
    [control]="control"
    [data]="data"
    uiFormError
  ></mat-error>
}
